import {
  BuyerAccessLevelOption,
  OperatorAccessLevelOption,
  SupplierAccessLevelOption,
} from './models/access-level-option.model';

/** Ported from legacy `operator.constant.ts` `Constants.ACCESS_LEVELS`. */
export const BASE_OPERATOR_ACCESS_LEVELS: readonly OperatorAccessLevelOption[] =
  [
    { value: 'limited', label: 'Limited' },
    { value: 'full', label: 'Full' },
    { value: 'admin', label: 'Admin' },
  ];

export const SERVICE_OPERATOR_ACCESS_LEVEL: OperatorAccessLevelOption = {
  value: 'serviceOperator',
  label: 'Service Operator',
};

export const SUPPLIER_ACCESS_LEVELS: readonly SupplierAccessLevelOption[] = [
  { value: 'limited', label: 'Limited' },
  { value: 'full', label: 'Full' },
  { value: 'admin', label: 'Admin' },
];

export const STANDARD_BUYER_ACCESS_LEVELS: readonly BuyerAccessLevelOption[] = [
  { kind: 'standard', value: 'limited', label: 'Limited' },
  { kind: 'standard', value: 'full', label: 'Full' },
  { kind: 'standard', value: 'admin', label: 'Admin' },
  { kind: 'standard', value: 'superAdmin', label: 'Super Admin' },
  { kind: 'standard', value: 'limitedDraft', label: 'Limited Draft' },
];

export const MULTI_BUYER_PM_ACCESS_LEVEL: BuyerAccessLevelOption = {
  kind: 'standard',
  value: 'multiBuyer',
  label: 'Multi Buyer PM',
};

export const MULTI_BUYER_MASTER_ACCESS_LEVEL: BuyerAccessLevelOption = {
  kind: 'standard',
  value: 'masterMultiBuyer',
  label: 'Master',
};

/** Shares the `multiBuyer` wire value with the PM option — see the model. */
export const MULTI_BUYER_MANAGER_ACCESS_LEVEL: BuyerAccessLevelOption = {
  kind: 'multiBuyerManager',
  value: 'multiBuyer',
  label: 'Multi Buyer Manager',
};
